export const getReport = (value, fecha_inicio="",fecha_fin="",id_punto_venta="",id_negocio="",id_municipio="",permit="",id_empresa="",id_usuario="",id_municipio_usuario="") => {
    let negocioSelect=false;
    let puntoSelect=false;
    let municipioSelect=false;
    let Items = [];
    let url = '';
    let urlDownload = '';
    switch (value) {
        case 'REPORTE GENERAL':
            Items = [
                {val:'folio_tarjeta',label:'Numero tarjeta'},
                {val:'nombre',label:'Nombre'},
                {val:'apellido_paterno',label:'Apellido paterno'},
                {val:'apellido_materno',label:'Apellido materno'},
                {val:'curp',label:'Curp'},
                {val:'fecha_nacimiento',label:'Fecha nacimiento'},
                {val:'edad',label:'Edad'},
                {val:'celular',label:'Celular'},
                {val:'colonia',label:'Colonia'}
            ];
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_general?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&permit=${permit}&id_empresa=${id_empresa}&id_user=${id_usuario}&id_municipio_usuario=${id_municipio_usuario}`;
            urlDownload = `https://mosacpruebas.com/reports.php?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&permit=${permit}&id_empresa=${id_empresa}&id_municipio=${id_usuario}`;
            break;

        case 'REPORTE DE VENTAS':
            Items = [
                {val:'precio_regular',label:'Total venta'},
                {val:'total_descuento',label:'Ahorro venta'},
                {val:'nombre_negocio',label:'Negocio'},
                {val:'nombre_punto_venta',label:'Punto venta'},
                {val:'fecha',label:'Fecha venta'}
            ];
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_ventas?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`;
            break;

        case 'REPORTE POR PUNTO DE VENTA':
            Items = [
                {val:'precio_regular',label:'Total venta'},
                {val:'total_descuento',label:'Ahorro venta'},
                {val:'nombre_negocio',label:'Negocio'},
                {val:'fecha',label:'Fecha venta'}
            ];
            negocioSelect = true;
            puntoSelect = true;
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_ventas?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_punto_venta=${id_punto_venta}&permit=${permit}&id_negocio=${id_negocio}`;
            break;
            
        case 'REPORTE GENERAL PARA NEGOCIOS':
            Items = [
                {val:'nombre',label:'Nombre'},
                {val:'apellidos',label:'Apellidos'},
                {val:'curp',label:'Curp'},
                {val:'fecha_nacimiento',label:'Fecha nacimiento'},
                {val:'edad',label:'Edad'},
                {val:'celular',label:'Teléfono'}, 
                {val:'colonia',label:'Colonia'},  
                {val:'fecha_venta',label:'Fecha ultima venta'},  
            ];
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_negocios?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_negocio=${id_negocio}&permit=${permit}&id_negocio=${id_negocio}`;
            // urlDownload = `https://argosservicios.com/reports.php?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_negocio=${id_negocio}`;
            negocioSelect = true;
            break;

        case 'REPORTE PARA NEGOCIOS':
            Items = [
                {val:'nombre_completo',label:'Nombre completo'},
                {val:'colonia',label:'Colonia'},
                {val:'folio_tarjeta',label:'Numero tarjeta'},
                {val:'nombre_negocio',label:'Negocio'},
                {val:'nombre_punto_venta',label:'Punto de venta'},
                {val:'fecha',label:'Fecha venta'}, 
                {val:'total_descuento',label:'Total ahorro'},  
                {val:'precio_regular',label:'Total venta'},  
            ];
            url = `http://ec2-18-237-53-89.us-west-2.compute.amazonaws.com:3010/app/reporte_negocios?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_negocio=${id_negocio}&permit=${permit}`;
            // url = `http://localhost:3010/app/reporte_negocios?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_negocio=${id_negocio}&permit=${permit}`;
            // urlDownload = `https://argosservicios.com/reports.php?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_negocio=${id_negocio}`;
            negocioSelect = true;
            break;

        case 'REPORTE POR USO DE TARJETA':
            Items = [
                {val:'folio',label:'Numero tarjeta'},
                {val:'nombre_negocio',label:'Negocio'},
                {val:'cantidad',label:'Veces de uso tarjeta'},
                {val:'nombre_municipio',label:'Municipio'},  
            ];
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_uso_tarjeta?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`;
            break;

        case 'REPORTE DE AHORRO POR NEGOCIO':
            Items = [
                {val:'folio',label:'Numero tarjeta'},
                {val:'nombre_municipio',label:'Municipio'},  
                {val:'colonia',label:'Colonia mujer'},
                {val:'total_descuento',label:'Total ahorrado'},
                {val:'nombre_negocio',label:'Negocio'},
            ];
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/reporte_ahorro?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`;
            break;

        case 'REPORTE TARJETAS ENTREGADAS GENERAL':
            Items = [
                {val:'folio',label:'Folio tarjeta'},
                {val:'punto_entrega',label:'Punto de entrega'},  
                {val:'fecha_entrega',label:'Fecha entrega'},
                {val:'responsable',label:'Responsable'},
            ];
            municipioSelect=true;
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/tarjetas_entregadas?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_municipio=${id_municipio}`;
            break;

        case 'REPORTE TARJETAS ENTREGADAS POR PUNTO DE ENTREGA':
            Items = [
                {val:'punto_entrega',label:'Punto de entrega'},  
                {val:'total_asignadas',label:'Tarjetas asignadas'},
                {val:'total_entregadas',label:'Tarjetas entregadas'},
            ];
            municipioSelect=true;
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/tarjetas_entregadas_punto?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_municipio=${id_municipio}`;
            break;

        case 'REPORTE TARJETAS ENTREGADAS POR COLONIA':
            Items = [  
                {val:'colonia',label:'Colonia de la mujer'},
                {val:'total_entregadas',label:'Tarjetas entregadas'},
            ];
            municipioSelect=true;
            url = `https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/tarjetas_entregadas?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&id_municipio=${id_municipio}&request=col`;
            break;
    
        default:
            break;
    }

    return {Items,url,negocioSelect,puntoSelect,urlDownload,municipioSelect};

}